import { Navigate, Route, Routes } from 'react-router-dom';

import { ComingSoon } from './components';
import {
  AssessmentForm,
  ClientInfoForm,
  CrisisPlanForm,
  DischargeForm,
  EducationForm,
  FamilyForm,
  InformationForm,
  MedicalForm,
  MedicationForm,
  ReferralForm,
  TherapyForm,
  TreatmentForm,
} from './components/forms';
import {
  TREATMENT_PLAN_V3_IMPLEMENTED_TAB_IDS,
  TREATMENT_PLAN_V3_TAB_CONFIGS,
  TREATMENT_PLAN_V3_TAB_IDS,
} from './constants';

export default function TreatmentPlanV3Routes() {
  return (
    <Routes>
      <Route index element={<Navigate replace to={TREATMENT_PLAN_V3_TAB_IDS.INFORMATION} />} />
      {TREATMENT_PLAN_V3_TAB_CONFIGS.filter(
        (tabConfig) => !TREATMENT_PLAN_V3_IMPLEMENTED_TAB_IDS.some((id) => id === tabConfig.id),
      ).map((tabConfig) => (
        <Route key={tabConfig.id} path={tabConfig.id} element={<ComingSoon />} />
      ))}
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.INFORMATION} element={<InformationForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.MEDICAL} element={<MedicalForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.REFERRAL} element={<ReferralForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.MEDICATION} element={<MedicationForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.THERAPY} element={<TherapyForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.EDUCATION} element={<EducationForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.FAMILY} element={<FamilyForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.CHILD} element={<ClientInfoForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.ASSESSMENT} element={<AssessmentForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.CRISIS} element={<CrisisPlanForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.DISCHARGE} element={<DischargeForm />} />
      <Route path={TREATMENT_PLAN_V3_TAB_IDS.TREATMENT} element={<TreatmentForm />} />
      <Route path="*" element={<Navigate replace to={TREATMENT_PLAN_V3_TAB_IDS.INFORMATION} />} />
    </Routes>
  );
}
